import angular from 'angular';
import { get } from 'lodash';
import '../../services/errors';
import '../../services/user';
import 'angular-sessionstorage'
import '../../services/place';

const module = angular.module('whyline.modals.box-label', [
  'whyline.services.errors',
  'whyline.services.user',
  'ngSessionStorage',
  'whyline.services.place',
]);

const BoxLabelModalController = (
  $rootScope,
  $scope,
  $timeout,
  $translate,
  $uibModalInstance,
  ErrorService,
  NotificationService,
  UserService,
  required,
  numericLabel,
  $sessionStorage,
  PlaceService,
) => {
  'ngInject';
  UserService.GetCurrentAsPromiseFromServer().then(
      currentUser => {
        PlaceService.GetCurrentAsPromise().then(place => {
          $scope.boxLabel = currentUser.boxLabels.find(boxLabel => boxLabel.placeId === place._id);
          $scope.userId = currentUser._id;
          $scope.currentPlaceId = place._id;
          $timeout(() => {
            $scope.label = get($scope, 'boxLabel.boxLabel', '');
          })   
        })
         
      }
  )
  const onlyNumbersPattern = /^[0-9]*$/i;
  const namePattern = /^[ '-:A-Za-z\xC0-\xCF\xD1-\xD6\xD8-\xDD\xDF-\xE5\xE7-\xF6\xF8-\xFD\xFF\u0104-\u0107\u010C\u010D\u0116-\u0119\u012E\u012F\u0141-\u0144\u0152\u0160\u0161\u016A\u016B\u0172\u0173\u0178-\u017E]+$/i;


  const validateLabel = (value) => {
    if((!required && !numericLabel) || (!required && numericLabel && value === '')){
      return true;
    } else if (numericLabel && value !== '') {
      if (!onlyNumbersPattern.test(value)) {
        NotificationService.Warning($translate.instant('char_forbidden_name'));
        return false;
      }
    }
    if (!value) {
      NotificationService.Warning(
        $translate.instant('box_label_mandatory'),
      );
      return false;
    }

    if ((value.length < 2 || value.length > 50) && !numericLabel) {
      NotificationService.Warning(
        $translate.instant('box_label_length'),
      );
      return false;
    }
    if (numericLabel) {
      if (!onlyNumbersPattern.test(value)) {
        NotificationService.Warning($translate.instant('char_forbidden_name'));
        return false;
      }
    } else {
      if (!namePattern.test(value)) {
        NotificationService.Warning($translate.instant('char_forbidden_name'));
        return false;
      }
    }
    

    return true;
  };

  $scope.$on('$stateChangeStart', () => {
    $uibModalInstance.close();
  });

  $scope.close = (isSaving) => {
    if(!isSaving){
      if(!$scope.boxLabel && required){
        NotificationService.Warning($translate.instant('box_label_empty'));
        return false;
      }
  
      if($scope.boxLabel && $scope.boxLabel.boxLabel === '' && required){
        NotificationService.Warning($translate.instant('box_label_empty'));
        return false;
      }
      $uibModalInstance.close();
      return false;
    }
    $uibModalInstance.close();
  };

  $scope.save = () => {
    if(validateLabel($scope.label)){
        UserService.UpdateBoxLabel($scope.userId, $scope.label)
        .then((user) => {
            NotificationService.Success($translate.instant('box_label_updated_correctly'));
            const currentLabel = user.data.boxLabels.filter(bl => bl.placeId === $scope.currentPlaceId);
            $rootScope.$broadcast('box-label-updated',currentLabel[0].boxLabel);
            $sessionStorage.put('boxLabelUpdated', true);
            $scope.close(true);
        })
        .catch(ErrorService.handler);
    }
  };
};

module.exports = module.controller(
  'BoxLabelModalController',
  BoxLabelModalController,
);